import React from "react";
import PropTypes from "prop-types";
import { parseFieldArea } from "utils";
import "./index.scss";

const TotalAreaCell = ({ value }) => (
  <div data-testid="total-area-cell" className="total-area-cell">
    <div className="cell-header">Total Area</div>
    <div>{parseFieldArea(value)} Ha</div>
  </div>
);

TotalAreaCell.propTypes = {
  value: PropTypes.number.isRequired,
};

export default TotalAreaCell;
